module.exports = __webpack_public_path__ + "img/info-9.84ad1066.svg";